import React from 'react';
import Finxheader from '../finxheader/finxheader';
import Finxfooter from '../finxfooter/finxfooter';
import FinxFooterLinks from "../finxfooter/finxfooterlinks"


 class Privacydetails extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                 <section className="privacy-policy pt-50 mb-50">
        <div className="container">
            <div className="row">
                <div className="col-md-12 col-sm-12">
                    <h1 className="text-center">Privacy Policy</h1>
                    <p>As a general rule, this website does not collect Personal Information about you when you visit the site. You can generally visit the site without revealing Personal Information, unless you choose to provide such information.</p>
                    <h5> A) SITE VISIT DATA:</h5>
                    <p>This website records your visit and logs the following information for statistical purposes:- your server’s address; the name of the top-level domain from which you access the Internet (for example, .gov, .com, .in, etc.); the type
                        of browser you use; the date and time of accessing the site; the pages you have accessed; the documents downloaded and the internet address from which you linked directly to the site.</p>
                    <p>We will not identify users or their browsing activities, except when a law enforcement agency may exercise a warrant to inspect the service provider’s logs.</p>
                    <h5>B) EMAIL MANAGEMENT:</h5>
                    <p>Your email address will only be recorded if you choose to send a message. It will only be used for the purpose for which you have provided it and will not be added to a mailing list. Your email address will not be used for any other
                        purpose, and will not be disclosed, without your consent.</p>
                    <h5>C) COLLECTION OF PERSONAL INFORMATION:</h5>
                    <p>If you are asked for any other Personal Information you will be informed how it will be used if you choose to give it. If at any time you believe the principles referred to in this privacy statement have not been followed, or have
                        any other comments on these principles, please notify the webmaster through the ‘contact us’ page.</p>
                    <h6 className="note">Note: The use of the term “Personal Information” in this Privacy Policy refers to any information from which your identity is apparent or can be reasonably ascertained.</h6>
                </div>
            </div>
        </div>
    </section>
              
              <FinxFooterLinks />
            </React.Fragment>
        );
    }

}


export default Privacydetails;